import React from "react";
import {Box, Flex} from "../../assets/ui";
import TopNav from "../TopNav";
import styled from "styled-components";
import BannerWorkWithUs from "../BannerWorkWithUs";
import OpenRoles from "../OpenRoles";
import MainStaff from "../MainStaff/indax";
import Footer from "../Footer";
import GiveUp from "../../components/GiveUp";

const FirstSkrinWrapper = styled(Flex)`
  background:  
    url("./images/banner-test.png");
    background-blend-mode: normal, multiply, normal;
  min-height: 100vh;
  background-size: auto 100%;
  background-position: 40% center;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 15%;
  @media (min-width: ${({ theme }) => theme.queries.xl}) {
  background-size: 105% auto;
}
  
`;
const StyledIntroduceWrapper = styled.div`
  position: relative;
  background: radial-gradient(
      100% 100% at 93.55% 94.42%,
      #ffffff 0%,
      rgba(0, 0, 0, 0.5) 100%
    ),
    #233247;
  background-blend-mode: multiply, normal;
  //work-with-us-bunner.png
`;

const WorkWithUs = () => {
  return (
    <Box>
      <StyledIntroduceWrapper>
        <FirstSkrinWrapper>
          <TopNav />
            <BannerWorkWithUs/>
        </FirstSkrinWrapper>
          <OpenRoles/>
      </StyledIntroduceWrapper>
        <MainStaff></MainStaff>
        <GiveUp/>
        <Footer/>
    </Box>
  );
};

export default WorkWithUs;
